const assemblyConstituencies = [
  "1-Akkalkuwa(ST)",
  "2-Shahada(ST)",
  "3-Nandurbar(ST)",
  "4-Nawapur(ST)",
  "5-Sakri(ST)",
  "6-Dhule Rural",
  "7-Dhule City",
  "8-Sindhkheda",
  "9-Shirpur(ST)",
  "10-Chopda(ST)",
  "11-Raver",
  "12-Bhusawal(SC)",
  "13-Jalgaon City",
  "14-Jalgaon Rural",
  "15-Amalner",
  "16-Erandol",
  "17-Chalisgaon",
  "18-Pachora",
  "19-Jamner",
  "20-Muktainagar",
  "21-Malkapur",
  "22-Buldhana",
  "23-Chikhli",
  "24-Sindhkhed Raja",
  "25-Mehkar(SC)",
  "26-Khamgaon",
  "27-Jalgaon(Jamod)",
  "28-Akot",
  "29-Balapur",
  "30-Aakola West",
  "31-Akola East",
  "32-Murtizapur(SC)",
  "33-Risod",
  "34-Washim(SC)",
  "35-Karanja",
  "36-Dhamangaon Railway",
  "37-Badnera",
  "38-Amrawati",
  "39-Teosa",
  "40-Daryapur(SC)",
  "41-Melghat(ST)",
  "42-Achalpur",
  "43-Morshi",
  "44-Arvi",
  "45-Deoli",
  "46-Hinganghat",
  "47-Wardha",
  "48-Katol",
  "49-Savner",
  "50-Hingna",
  "51-Umred(SC)",
  "52-Nagpur South West",
  "53-Nagpur South",
  "54-Nagpur East",
  "55-Nagpur Central",
  "56-Nagpur West",
  "57-Nagpur North(SC)",
  "58-Kamthi",
  "59-Ramtek",
  "60-Tumsar",
  "61-Bhandara(SC)",
  "62-Sakoli",
  "63-Arjuni Morgaon(SC)",
  "64-Tirora",
  "65-Gondia",
  "66-Amgaon(ST)",
  "67-Armori(ST)",
  "68-Gadchiroli(ST)",
  "69-Aheri(ST)",
  "70-Rajura",
  "71-Chandrapur(SC)",
  "72-Ballarpur",
  "73-Bramhapuri",
  "74-Chimur",
  "75-Warora",
  "76-Wani",
  "77-Ralegaon(ST)",
  "78-Yavatmal",
  "79-Digras",
  "80-Arni(ST)",
  "81-Pusad",
  "82-Umarkhed(SC)",
  "83-Kinwat",
  "84-Hidgaon",
  "85-Bhokar",
  "86-Nanded North",
  "87-Nanded south",
  "88-Loha",
  "89-Naigaon",
  "90-Deglur(sc)",
  "91-Mukhed",
  "92-Basmath",
  "93-Kalamnuri",
  "94-Hingoli",
  "95-Jintur",
  "96-Parbhani",
  "97-Gangakhed",
  "98-Pathri",
  "99-Partur",
  "100-Gansavangi",
  "101-Jalna",
  "102-Badnapur(SC)",
  "103-Bhokardan",
  "104-Sillod",
  "105-Kannad",
  "106-Pholambari",
  "107-Chatrapati Sambhaji Nagar(Central)",
  "108-Chatrapati Sambhaji Nagar(West)(SC)",
  "109-Aurangbad(East)",
  "110-Paithan",
  "111-Gangapur",
  "112-Vaijapur",
  "113-Nandgaon",
  "114-Malegaon(Central)",
  "115-Malegaon(Outer)",
  "116-Baglan(ST)",
  "117-Kalwan(ST)",
  "118-Chandwad",
  "119-Yevla",
  "120-Sinnar",
  "121-Niphad",
  "122-Dindori(ST)",
  "123-Nashik East",
  "124-Nashik(Central)",
  "125-Nashik West",
  "126-Deolali(SC)",
  "127-Igatpuri(ST)",
  "128-Dahanu(ST)",
  "129-Vekramgrth(ST)",
  "130-Palghar(ST)",
  "131-Boisar(ST)",
  "132-Nalasopara",
  "133-Vasai",
  "134-Bhiwandi Rural(ST)",
  "135-Shahapur(ST)",
  "136-Bhiwandi West",
  "137-Bhiwandi East",
  "138-Kalyan West",
  "139-Murbad",
  "140-Ambarnath(SC)",
  "141-Ulhasnagar",
  "142-Kalyan East",
  "143-Dombivali",
  "144-Kalyan Rural",
  "145-Meera Bhayandar",
  "146-ovala majiwada",
  "147-Kopri-Pachpakhadi",
  "148-Thane",
  "149-Mumbra-Kalwa",
  "150-Airoli",
  "151-Belapur",
  "152-Borivali",
  "153-Dhaisar",
  "154-Magathane",
  "155-Mulund",
  "156-Vikhroli",
  "157-Bhandup West",
  "158-Jogeshwari East",
  "159-Dindoshi",
  "160-Kandivali East",
  "161-Charkop",
  "162-Malad West",
  "163-Goregaon",
  "164-Varsova",
  "165-Andheri West",
  "166-Andheri East",
  "167-Vile Parle",
  "168-Chandivali",
  "169-Ghatkopar West",
  "170-Ghatkopar East",
  "171-Mankhurd Shivajinagar",
  "172-Anushakti Nagar",
  "173-Chembur",
  "174-Kurla (sc)",
  "175-Kalina",
  "176-Vandre East",
  "177-Vandre West",
  "178-Dharavi",
  "179-Sion Koliwada",
  "180-Wadala",
  "181-Mahim",
  "182-Worli",
  "183-Shivadi",
  "184-Byculla",
  "185-Malabar Hill",
  "186-Mumbadevi",
  "187-Colaba",
  "188-Panvel",
  "189-Karjat",
  "190-Uran",
  "191-Pen",
  "192-alibag",
  "193-Shrivardhan",
  "194-mahad",
  "195-Junnar",
  "196-Ambegaon",
  "197-Khed Alandi",
  "198-Shirur",
  "199-Daund",
  "200-Indapur",
  "201-Baramati",
  "202-Purandar",
  "203-Bhor",
  "204-Maval",
  "205-Chinchwad",
  "206-Pimpri(SC)",
  "207-Bhosari",
  "208-Vadgaon Sheri",
  "209-Shivajinagar",
  "210-Kothrud",
  "211-Khadakwasala",
  "212-Parvati",
  "213-Hadapsar",
  "214-Pune Cantonment(SC)",
  "215-Kasba Peth",
  "216-Akole(ST)",
  "217-Sangmner",
  "218-Shirdi",
  "219-Kopargaon",
  "220-Shrirampur(SC)",
  "221-Nevasa",
  "222-Shevgaon",
  "223-Rahuri",
  "224-Parner",
  "225-Ahmednagar City",
  "226-Shrigonda",
  "227-Karjat Jamkhed",
  "228-Georai",
  "229-Majalgaon",
  "230-Beed",
  "231-Ashti",
  "232-Kaij(SC)",
  "233-Parli",
  "234-Latur Rural",
  "235-Latur City",
  "236-Ahmedpur",
  "237-Udgir(SC)",
  "238-Nilanga",
  "239-Ausa",
  "240-Omerga(SC)",
  "241-Tuljapur",
  "242-Dharashiv",
  "243-Paranda",
  "244-Karmala",
  "245-Madha",
  "246-Barshi",
  "247-Mohol(SC)",
  "248-solapur north",
  "249-solapur central",
  "250-Akkalkot",
  "251-Solapur South",
  "252-Pandharpur",
  "253-Sangola",
  "254-Malshiran(SC)",
  "255-Phaltan(SC)",
  "256-Wai",
  "257-koregaon",
  "258-Man",
  "259-Karad North",
  "260-Karad South",
  "261-patan",
  "262-Satara",
  "263-Dapoli",
  "264-Guhagar",
  "265-Chiplun",
  "266-Ratnagiri",
  "267-Rajapur",
  "268-Kankavli",
  "269-Kudal",
  "270-Sawantwadi",
  "271-Chandgad",
  "272-Radhanagari",
  "273-kagal",
  "274-Kolhapur South",
  "275-Karvir",
  "276-Kolhapur North",
  "277-Shahuwadi",
  "278-Hatkanangle(SC)",
  "279-Ichalkaranji",
  "280-Shirol",
  "281-Miraj(SC)",
  "282-Sangli",
  "283-islampur",
  "284-Shirala",
  "285-Palus-Kadegaon",
  "286-Khanpur",
  "287-Tasgaon-Kavathe",
  "288-Jat",
];

const districtRoles = [
  "Ahmednagar",
  "Akola",
  "Washim",
  "Amravati",
  "Chhatrapati Sambhaji Nagar",
  "Pune",
  "Beed",
  "Bhandara",
  "Gondiya",
  "Thane",
  "Buldhana",
  "Chandrapur",
  "Yavatmal",
  "Dhule",
  "Nashik",
  "Gadchiroli",
  "Kolhapur",
  "Sangli",
  "Nanded",
  "Hingoli",
  "Jalgaon",
  "Jalna",
  "Latur",
  "Solapur",
  "Satara",
  "Raigad",
  "Mumbai (Suburban)",
  "Mumbai City",
  "Nagpur",
  "Nandurbar",
  "Dharashiv",
  "Palghar",
  "Parbhani",
  "Ratnagiri",
  "Sindhudurg",
  "Wardha",
];

const parliamentaryConstituencyRoles = [
  "1-Nandurbar (ST)",
  "10-Nagpur",
  "11-Bhandara-Gondiya",
  "12-Gadchiroli-Chimur (ST)",
  "13-Chandrapur",
  "14-Yavatmal-Washim",
  "15-Hingoli",
  "16-Nanded",
  "17-Parbhani",
  "18-Jalna",
  "19-Chatrapati Sambhaji Nagar",
  "2-Dhule",
  "20-Dindori (ST)",
  "21-Nashik",
  "22-Palghar (ST)",
  "23-Bhiwandi",
  "24-Kalyan",
  "25-Thane",
  "26-Mumbai North",
  "27-Mumbai North-West",
  "28-Mumbai North-East",
  "29-Mumbai North-Central",
  "3-Jalgaon",
  "30-Mumbai South-Central",
  "31-Mumbai South",
  "32-Raigad",
  "33-Maval",
  "34-Pune",
  "35-Baramati",
  "36-Shirur",
  "37-Ahmednagar",
  "38-Shirdi (SC)",
  "39-Beed",
  "4-Raver",
  "40-Dharashiv",
  "41-Latur (SC)",
  "42-Solapur (SC)",
  "43-Madha",
  "44-Sangli",
  "45-Satara",
  "46-Ratnagiri-Sindhudurg",
  "47-Kolhapur",
  "48-Hatkanangle",
  "5-Buldhana",
  "6-Akola",
  "7-Amravati (SC)",
  "8-Wardha",
  "9-Ramtek (SC)",
];

const zoneRoles = [
  "Eastern Vidarbha",
  "Konkan",
  "Marathwada",
  "Mumbai",
  "Northern Maharashtra",
  "Thane + Palghar",
  "Western Maharashtra",
  "Western Vidarbha",
];

const assemblyConstituenciesAp = [
  "6-Amadalavalasa",
  "7-Etcherla",
  "1-Ichapuram",
  "8-Narasannapeta",
  "10-Palakonda",
  "2-Palasa",
  "4-Pathapatnam",
  "9-Rajam",
  "5-Srikakulam",
  "3-Tekkali",
  "14-Bobbili",
  "15-Cheepurupalli",
  "16-Gajapathinagaram",
  "11-Kurupam",
  "17-Nellimarla",
  "12-Parvathipuram",
  "13-Salur",
  "19-Srungavarapukota",
  "18-Vizianagaram",
  "30-Anakapalli",
  "28-Araku Valley",
  "20-Bhimili",
  "26-Chodavaram",
  "32-Elamanchili",
  "25-Gajuwaka",
  "27-Madugula",
  "34-Narsipatnam",
  "29-Paderu",
  "33-Payakaraopeta",
  "31-Pendurthi",
  "21-Visakhapatnam East",
  "23-Visakhapatnam North",
  "22-Visakhapatnam South",
  "24-Visakhapatnam West",
  "44-Amalapuram",
  "40-Anaparthy",
  "46-Gannavaram (Eg)",
  "52-Jaggampeta",
  "41-Kakinada City",
  "38-Kakinada Rural",
  "47-Kothapeta",
  "48-Mandapeta",
  "43-Mummidivaram",
  "39-Peddapuram",
  "37-Pithapuram",
  "36-Prathipad",
  "50-Rajahmundry City",
  "51-Rajahmundry Rural",
  "49-Rajanagaram",
  "42-Ramachandrapuram",
  "53-Rampachodavaram",
  "45-Razole",
  "35-Tuni",
  "56-Achanta",
  "59-Bhimavaram",
  "68-Chintalapudi",
  "64-Dendulur",
  "65-Eluru",
  "66-Gopalpuram",
  "54-Kovvur",
  "58-Narasapur",
  "55-Nidadavole",
  "57-Palacole",
  "67-Polavaram",
  "62-Tadepalligudem",
  "61-Tanuku",
  "60-Undi",
  "63-Ungutur",
  "76-Avanigadda",
  "71-Gannavaram (Krishna)",
  "72-Gudivada",
  "84-Jaggayyapet",
  "73-Kaikalur",
  "75-Machilipatnam",
  "82-Mylavaram",
  "83-Nandigama",
  "70-Nuzvid",
  "77-Pamarru",
  "74-Pedana",
  "78-Penamaluru",
  "69-Tiruvuru",
  "80-Vijayawada Central",
  "81-Vijayawada East",
  "79-Vijayawada West",
  "92-Bapatla",
  "96-Chilakaluripet",
  "95-Guntur East",
  "94-Guntur West",
  "100-Gurzala",
  "101-Macherla",
  "87-Mangalagiri",
  "97-Narasaraopet",
  "85-Peddakurapadu",
  "88-Ponnur",
  "93-Prathipadu",
  "90-Repalle",
  "98-Sattenapalli",
  "86-Tadikonda",
  "91-Tenali",
  "89-Vemuru",
  "99-Vinukonda",
  "105-Addanki",
  "106-Chirala",
  "103-Darsi",
  "112-Giddalur",
  "109-Kandukur",
  "113-Kanigiri",
  "110-Kondepi",
  "111-Markapur",
  "108-Ongole",
  "104-Parchur",
  "107-Santhanuthalapadu",
  "102-Yerragondapalem",
  "115-Atmakur",
  "120-Gudur",
  "114-Kavali",
  "116-Kovur",
  "117-Nellore City",
  "118-Nellore Rural",
  "119-Sarvepalli",
  "121-Sullurpet",
  "123-Udayagiri",
  "122-Venkatagiri",
  "124-Badvel",
  "131-Jammalamadugu",
  "126-Kadapa",
  "130-Kamalapuram",
  "127-Kodur",
  "133-Mydukur",
  "132-Proddatur",
  "129-Pulivendla",
  "125-Rajampet",
  "128-Rayachoty",
  "146-Adoni",
  "134-Allagadda",
  "147-Alur",
  "140-Banaganapalle",
  "141-Dhone",
  "143-Kodumur",
  "137-Kurnool",
  "145-Mantralayam",
  "136-Nandikotkur",
  "139-Nandyal",
  "138-Panyam",
  "142-Pattikonda",
  "135-Srisailam",
  "144-Yemmiganur",
  "153-Anantapur Urban",
  "160-Dharmavaram",
  "150-Guntakal",
  "157-Hindupur",
  "161-Kadiri",
  "154-Kalyandurg",
  "156-Madakasira",
  "158-Penukonda",
  "159-Puttaparthi",
  "155-Raptadu",
  "148-Rayadurg",
  "152-Singanamala",
  "151-Tadpatri",
  "149-Uravakonda",
  "166-Chandragiri",
  "172-Chittoor",
  "171-Gangadhara Nellore",
  "175-Kuppam",
  "164-Madanpalle",
  "170-Nagari",
  "174-Palamaner",
  "163-Pileru",
  "165-Punganur",
  "173-Puthalapattu",
  "169-Satyavedu",
  "168-Srikalahasti",
  "162-Thamballapalle",
  "167-Tirupati",
];

const districtRolesAp = [
  "Srikakulam",
  "Parvathipuram Manyam",
  "Vizianagaram",
  "Anakapalli",
  "Alluri Sitharama Raju",
  "Visakhapatnam",
  "Konaseema",
  "East Godavari",
  "Kakinada",
  "West Godavari",
  "Eluru",
  "Krishna",
  "NTR",
  "Bapatla",
  "Palnadu",
  "Guntur",
  "Prakasam",
  "Nellore",
  "Tirupati",
  "Kadapa",
  "Annamayya",
  "Kurnool",
  "Nandyal",
  "Anantapur",
  "Sri Sathya Sai",
  "Chittoor",
];

const parliamentaryConstituencyRolesAp = [
  "2-Srikakulam",
  "3-Vizianagaram",
  "1-Araku",
  "4-Visakhapatnam",
  "5-Anakapalli",
  "7-Amalapuram",
  "8-Rajahmundry",
  "6-Kakinada",
  "9-Narsapuram",
  "10-Eluru",
  "11-Machilipatnam",
  "12-Vijayawada",
  "15-Bapatla",
  "14-Narasaraopet",
  "13-Guntur",
  "16-Ongole",
  "22-Nellore",
  "23-Tirupati",
  "21-Kadapa",
  "24-Rajampet",
  "18-Kurnool",
  "17-Nandyal",
  "19-Anantapur",
  "20-Hindupur",
  "25-Chittoor",
];

const zoneRolesAp = ["Zone 1", "Zone 2", "Zone 3", "Zone 4", "Zone 5"];

export {
  assemblyConstituencies,
  districtRoles,
  parliamentaryConstituencyRoles,
  zoneRoles,
  zoneRolesAp,
  districtRolesAp,
  parliamentaryConstituencyRolesAp,
  assemblyConstituenciesAp,
};
